<template>
    <MaltImg :src="photoSrcWithoutQueryParams" :alt="alt || 'photo'" :width="360" :height="360" :quality="90" :modifiers="modifiers" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {MaltImg} from '#components';

    interface ProfilePhotoProps {
        photoUrl: string;
        alt?: string;
        faceCrop?: boolean;
    }

    const props = defineProps<ProfilePhotoProps>();

    const modifiers = computed(() => {
        if (!props.faceCrop) {
            return {};
        }

        return {
            gravity: 'face',
            func: 'face',
            face_margin: 100,
        };
    });

    // Prevent conflict with CDN modifiers query params
    const photoSrcWithoutQueryParams = computed(() => props.photoUrl.split('?')[0] ?? '');
</script>

<style lang="scss" scoped>
    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
</style>
